import React from "react";
import Drawer from "material-ui/Drawer";
import DrawerNew from "@techsoftware/happay-widgets/Drawer";

export default class CustomDrawer extends React.PureComponent {
    render() {
        const {
            open,
            openSecondary,
            docked,
            containerStyle = {},
            overlayStyle = {},
            zDepth,
            width,
            style
        } = this.props;
        if (this.props.isWidgetComp) {
            return (
                <DrawerNew
                    {...this.props}
                    open={open ? open : false}
                    onClose={this.props.onRequestChange}
                />
            );
        }
        return (
            <Drawer
                id="expense-drawer"
                {...this.props}
                open={open ? open : false}
                width={width}
                containerStyle={Object.assign({}, containerStyle)}
                docked={docked}
                zDepth={zDepth}
                overlayStyle={Object.assign({}, overlayStyle)}
                openSecondary={openSecondary}
                style={Object.assign({}, style)}
            />
        );
    }
}
